import React from 'react'
import PeopleMergeFlow from './components/people/MergeFlow'
import PageHeader from 'components/Layout/PageHeader'

const PeopleMergeForm = () => {
  return (
    <>
      <PageHeader
        title="Preview and Merge People Profiles"
        subtitle="Please ensure all data is correct and up-to-date. If any FactSet data requires updating please raise an RPD."
      />
      <PeopleMergeFlow />
    </>
  )
}

export default PeopleMergeForm
